module.exports = __webpack_public_path__ + "static/media/sahnoun.5c228af1.jpg";